import { useContext } from 'react';
import { UserContext } from './UserContext';
import { Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import logoSidebar from './assets/img/logo-sidebar.svg';
import SidebarNavItems from './SidebarNavItems';

const Sidebar = ({ ticketCount = 0 }) => {

    return (
        <aside className="sidebar d-none d-lg-block">
            {/* Logo */}
            <Link className="logo" to="/">
                <Image src={logoSidebar} alt="aBROADIFY" title="aBROADIFY" />
            </Link>

            {/* ✅ Shared nav */}
            <SidebarNavItems ticketCount={ticketCount} />

        </aside>
    );
};

export default Sidebar;
